module.exports = "div.mat-dialog-content{\n  white-space: pre;\n}\n"